import { render, staticRenderFns } from "./SessionSettings.vue?vue&type=template&id=28c2f386"
import script from "./SessionSettings.vue?vue&type=script&lang=js"
export * from "./SessionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports